'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verifyNewCustomerEmail = function verifyNewCustomerEmail() {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  return regex.test($('.js-signup-email-input').val());
  // return Helpers.checkEmail($('.js-signup-email-input').val());
};

var verifyNewCustomerPassword = function verifyNewCustomerPassword() {
  var password = $('.js-signup-password-input').val();
  var minLength = 6;
  var isMinLength = password.length >= minLength;

  var integerRegExp = /\d+/;
  var hasNumber = false;

  if (password.match(integerRegExp) != null) {
    hasNumber = true;
  }

  return isMinLength && hasNumber;
};

var updateLoginLandingPage = function updateLoginLandingPage() {
  var loginFormRedirect = '<input type="hidden" name="checkout_url" value="/account?view=mvmt-insider"/>';

  if (window.location.href.indexOf('/account/login')) {
    if (window.Cookies.get('login_insider_redirect')) {
      $('form#customer_login').each(function (index, element) {
        $(element).prepend(loginFormRedirect);
      });
    }
  } else if (window.location.href.indexOf('/account/register')) {
    if (window.Cookies.get('login_insider_redirect')) {
      $('form#create_customer').each(function (index, element) {
        $(element).prepend(loginFormRedirect);
      });
    }
  } else if (window.location.href.indexOf('view=mvmt-insider')) {
    window.Cookies.remove('login_insider_redirect');
  }
};

var bindActions = exports.bindActions = function bindActions() {
  var _this = this;

  $(_Dom2.default.formInput).find('input').on('focus click', function (_ref) {
    var self = _ref.currentTarget;

    $(self).parent().find('label').addClass('in-focus');
  }).on('focusout', function (_ref2) {
    var self = _ref2.currentTarget;

    if ($(self).val() === '') {
      $(_this).parent().find('label').removeClass('in-focus');
    }
  }); // change styles on form inputs when we focus on them

  $(_Dom2.default.formTextarea).find('textarea').on('focus click', function (_ref3) {
    var self = _ref3.currentTarget;

    if ($(self).val() === 'Message...') {
      $(self).val('');
    }
  }).on('focusout', function (_ref4) {
    var self = _ref4.currentTarget;

    if ($(self).val() === '') {
      $(self).val('Message...');
    }
  });

  $(_Dom2.default.formSwap).on('click', function (event) {
    event.stopPropagation();
    if ($(_Dom2.default.login).is(':visible')) {
      $(_Dom2.default.login).hide();
      $(_Dom2.default.forgotPass).show();
    } else {
      $(_Dom2.default.login).show();
      $(_Dom2.default.forgotPass).hide();
    }
  });

  $(_Dom2.default.addAddress).on('click', function () {
    if (window.Shopify && window.Shopify.CustomerAddress) {
      window.Shopify.CustomerAddress.toggleNewForm();
    }
    return false;
  });

  $('.order a').click(function (event) {
    if (window.width() < 767) {
      event.preventDefault();
    }
  });

  $('#customer_logout_link').click(function () {
    window.Hull.logout();
  });

  $(document).on('click', '[data-create-customer-page-toggle]', function (_ref5) {
    var self = _ref5.currentTarget;

    // event.preventDefault();
    var newActivePageTarget = $(self).attr('data-create-customer-page-toggle');

    if (newActivePageTarget === '1') {
      $('[data-create-customer-page="1"]').removeClass('hidden');
      $('[data-create-customer-page="2"]').addClass('hidden');
    } else if (newActivePageTarget === '2') {
      if (verifyNewCustomerEmail()) {
        if (verifyNewCustomerPassword()) {
          $('[data-create-customer-page="1"]').addClass('hidden');
          $('[data-create-customer-page="2"]').removeClass('hidden');
        } else {
          $('.js-signup-password').addClass('signup-error-text');
        }
        $('.js-signup-error-text').addClass('hidden');
      } else {
        if (verifyNewCustomerPassword()) {
          $('.js-signup-password').removeClass('is-error');
        } else {
          $('.js-signup-password').addClass('is-error');
        }
        $('.js-signup-error-text').removeClass('hidden');
      }
    }

    return false;
  });

  $(document).on('submit', 'form#create_customer', function () {
    var newCustomer = {};

    newCustomer.birthDay = $('select[name="customer-preferences__birth-day"]').val();
    newCustomer.birthMonth = $('select[name="customer__birth-month"]').val();
    newCustomer.birthYear = $('select[name="customer__birth-year"]').val();
    newCustomer.gender = $('input[name="customer-preferences__gender"]:checked').val();
    newCustomer.discountAndSale = $('input[name="customer-preferences__discounts-and-sales"]').is(':checked');
    newCustomer.womens = $('input[name="customer-preferences__womens-products"]').is(':checked');
    newCustomer.mens = $('input[name="customer-preferences__mens-products"]').is(':checked');
    newCustomer.new = $('input[name="customer-preferences__new-products"]').is(':checked');

    window.Cookies.set('create_customer_preferences', JSON.stringify(newCustomer));
  });

  $(document).on('click', '.js-clear-email-preferences', function () {
    $('.js-email-preference').prop('checked', false);
  });
};

var init = exports.init = function init() {
  updateLoginLandingPage();

  for (var i = 0; i < $(_Dom2.default.formInput).length; i++) {
    var $this = $(_Dom2.default.formInput).eq(i);

    if ($this.find('input').val() && !$this.hasClass('form-input-checkbox')) {
      $this.find('label').addClass('in-focus');
    }
  } // making sure that this is set if the form has a value on page load.

  if (window.location.hash.indexOf('#recover') > -1) {
    $(_Dom2.default.login).hide();
    $(_Dom2.default.forgotPass).show();
  }

  if ($(_Dom2.default.resetSuccess) && $(_Dom2.default.resetSuccess).length > 0) {
    $(_Dom2.default.resetSuccess).insertAfter($('#log-in h2'));
  }
};

exports.default = {
  init: init,
  bindActions: bindActions
};